export default __webpack_public_path__ + "static/media/square-roundel-smaller.6198533c.png";